import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './LoginPage';
import StudentRegistration from './StudentRegistration';
import AdminDashboard from './AdminDashboard';
// New modular component imports
import FacultyDashboard from './components/faculty/FacultyDashboard';
import StudentDashboard from './components/student/StudentDashboard';
import WeekLearningView from './components/student/WeekLearningView';
import EditCourse from './EditCourse';

// Simple role-based protection component
const ProtectedRoute = ({ allowedRoles, children }) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const role = (user.role || user.user_type || '').toString().toLowerCase();

  // Not logged in → go to login
  if (!user || !user.user_id) {
    return <Navigate to="/" replace />;
  }

  // Wrong role → redirect to correct dashboard or login
  if (allowedRoles && !allowedRoles.includes(role)) {
    if (role === 'admin') {
      return <Navigate to="/admin-dashboard" replace />;
    }
    if (role === 'faculty') {
      return <Navigate to="/faculty-dashboard" replace />;
    }
    if (role === 'student') {
      return <Navigate to="/student-dashboard" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Public route */}
        <Route path="/" element={<LoginPage />} />
        
        {/* Student Registration Route */}
        <Route path="/register" element={<StudentRegistration />} />

        {/* Central dashboard - redirects based on role */}
        <Route
          path="/dashboard"
          element={
            (() => {
              const user = JSON.parse(localStorage.getItem('user') || '{}');
              const role = (user.role || user.user_type || '').toString().toLowerCase();
              if (!user.user_id) return <Navigate to="/" replace />;
              if (role === 'admin') return <Navigate to="/admin-dashboard" replace />;
              if (role === 'faculty') return <Navigate to="/faculty-dashboard" replace />;
              if (role === 'student') return <Navigate to="/student-dashboard" replace />;
              return <div>Invalid role. Please contact admin.</div>;
            })()
          }
        />

        {/* Admin Routes */}
        <Route
          path="/admin-dashboard"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />

        {/* Faculty Routes */}
        <Route
          path="/faculty-dashboard"
          element={
            <ProtectedRoute allowedRoles={['faculty']}>
              <FacultyDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/faculty/courses/edit/:courseId"
          element={
            <ProtectedRoute allowedRoles={['faculty']}>
              <EditCourse />
            </ProtectedRoute>
          }
        />

        {/* Student Routes */}
        <Route
          path="/student-dashboard"
          element={
            <ProtectedRoute allowedRoles={['student']}>
              <StudentDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/student-dashboard/course/:courseId"
          element={
            <ProtectedRoute allowedRoles={['student']}>
              <WeekLearningView />
            </ProtectedRoute>
          }
        />

        {/* Catch-all - redirect to login or dashboard */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;